import { Icon } from "../../../components/Component";
import { useState, useEffect } from "react";
import SimpleBar from "simplebar-react";
import { useDebounce } from "use-debounce";
import moment from "moment";

/**
 * IgChatSearchSidebar — sidebar search pesan conversation IG.
 *
 * Props:
 *   searchSidebar: boolean — apakah sidebar visible
 *   messages: array — daftar pesan yang sudah di-load di IgChatBody
 *   onSelectMessage: function(messageId) — dipanggil saat user klik hasil search
 *   close: function() — menutup sidebar
 */
const IgChatSearchSidebar = ({ searchSidebar, messages, onSelectMessage, close }) => {
  const [filteredMessages, setFilteredMessages] = useState([]);
  const [inputText, setInputText] = useState("");
  const [searchText] = useDebounce(inputText, 500);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const m = moment(dateStr);
    if (!m.isValid()) return "";
    const diff = moment().startOf("day").diff(m.clone().startOf("day"), "days");
    if (diff === 0) return m.format("HH:mm");
    if (diff === 1) return "Yesterday";
    return m.format("D MMM YYYY");
  };

  const boldText = (text) => {
    if (!text || !searchText) return { __html: text || "" };
    const escaped = searchText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(escaped, "gi");
    return { __html: text.replace(regex, (match) => `<b>${match}</b>`) };
  };

  const searchMessage = (text) => {
    if (!text) { setFilteredMessages([]); return; }
    const lower = text.toLowerCase();
    const results = messages
      .filter((msg) => msg.direction !== "system" && msg.text?.toLowerCase().includes(lower))
      .slice()
      .reverse();
    setFilteredMessages(results);
  };

  useEffect(() => {
    searchMessage(searchText);
  }, [searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setInputText("");
    setFilteredMessages([]);
  }, [searchSidebar]);

  const handleClickResult = (e, message) => {
    e.preventDefault();
    onSelectMessage(message.message_id);
    close();
  };

  return (
    <SimpleBar className={`nk-chat-profile ${searchSidebar ? "visible" : ""}`}>
      <div className="d-flex align-items-center search-message-header">
        <Icon name="cross" style={{ fontSize: "12pt", cursor: "pointer" }} onClick={close} />
        <span className="search-message-title ml-2">Search Messages</span>
      </div>
      <div className="search-message-body">
        <div className="search-message-input">
          <div className="form-group">
            <div className="form-control-wrap">
              <div className="form-icon form-icon-left">
                <Icon name="search" />
              </div>
              <input
                value={inputText}
                className="form-control"
                type="text"
                onChange={(e) => setInputText(e.target.value)}
                placeholder="Search message..."
              />
            </div>
          </div>
        </div>
        <SimpleBar>
          {filteredMessages.length > 0 ? (
            filteredMessages.map((message) => (
              <div
                key={message.message_id}
                className="search-message-content border-bottom"
                style={{ cursor: "pointer" }}
                onClick={(e) => handleClickResult(e, message)}
              >
                <div style={{ fontSize: 11, color: "#8094ae", marginBottom: 2 }}>
                  {formatDate(message.created_time || message.created_at)}
                </div>
                <div>
                  <span dangerouslySetInnerHTML={boldText(message.text)} />
                </div>
              </div>
            ))
          ) : searchText !== "" ? (
            <p className="text-center mt-3" style={{ fontSize: 13 }}>No message found</p>
          ) : null}
        </SimpleBar>
      </div>
    </SimpleBar>
  );
};

export default IgChatSearchSidebar;
